import { CMPR_INTERACT_EVENT, dispatchCmprEvent } from '@campact/camper/utils';

export class TrackingService {
  dispatchSendForm(form, { context, value = '' }) {
    dispatchCmprEvent(form, CMPR_INTERACT_EVENT, {
      event: 'cmpr-send-form',
      camperWebComponent: 'cmpr-form',
      context: context,
      innerText: '',
      value: value,
    });
  }

  dispatchGraphicClick(target) {
    dispatchCmprEvent(target, CMPR_INTERACT_EVENT, {
      event: 'cmpr-graphic-click',
      camperWebComponent: 'cmpr-graphic',
    });
  }
}

export default new TrackingService();
